import { MutateFunction } from '@tanstack/react-query';
import http from '../utils/http';

const magicLinkRequest: MutateFunction<
  string,
  Error,
  { email: string }
> = async ({ email }) => {
  const response = await http<{ message: string }>(
    `/shared/auth/magic-link/request`,
    {
      method: 'POST',
      body: {
        email,
        redirectUrl: globalThis.location?.href ?? '',
      },
    },
  );

  if (response.status === 200)
    return (
      response.data?.message ??
      'If an account exists for this email, a magic login link will be sent shortly.'
    );

  throw new Error('Failed to request magic link');
};

export default magicLinkRequest;
